import empty from "empty";

export const applyLoading = (state = empty.object, { loading }) =>
  state.loading === loading ||
  (state.loading === "success" && loading !== "error")
    ? state
    : { ...state, loading };
